import React from 'react';
import { Switch } from '@cotera/client/v0/components/ui/switch';

/**
 * The share panel's on/off control. The stock switch sizes its thumb to the
 * track's inside, so the circle touches the edges; this one leaves an even
 * 2px around it: a 36×20 track with a 1px border and 2px padding, and a 14px
 * thumb that travels 16px (30px inside, less the thumb).
 */
export const ShareSwitch: React.FC<React.ComponentProps<typeof Switch>> = (
  props
) => (
  <Switch
    {...props}
    className="h-[20px] w-[36px] rounded-full px-[2px] shadow-none"
    thumbClassName="size-[14px] shadow-sm data-[state=checked]:translate-x-[16px]"
  />
);
